import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  EnvelopeOpenIcon,
  UsersIcon,
  ClockIcon,
} from "@heroicons/react/24/outline";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { Auth } from "aws-amplify";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
  Field,
} from "@headlessui/react";
import { sendSurveyFromAPI } from "../../../services/surveyService";

export default function CollectOverview() {
  const themeMode = useSelector((state) => state.themeMode);
  // const surveyRecipients = useSelector(state => state.surveyRecipients);
  const topMenuTabs = useSelector((state) => state.topMenuTabs);

  const currentSurvey = topMenuTabs.tabs.find(
    (tab) => tab.id === topMenuTabs.activeTab
  ).states.currentSurvey;

  // const themeMode = topMenuTabs.tabs.find(
  //   (tab) => tab.id === topMenuTabs.activeTab
  // ).states.themeMode;
  const surveyRecipients = topMenuTabs.tabs.find(
    (tab) => tab.id === topMenuTabs.activeTab
  ).states.surveyRecipients;

  let [token, setToken] = useState("");
  const [respondents, setRespondents] = useState(0);
  const [completed, setCompleted] = useState(0);
  const [partial, setPartial] = useState(0);
  const [filteredSearchData, setFilteredSearchData] = useState([]);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [filterSearchTerm, setFilterSearchTerm] = useState("");
  const [selectedLabel, setSelectedLabel] = useState(""); // Store selected label
  const [infoText, setInfoText] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [clearFilter, setClearFilter] = useState(true);
  const [selectedFilterItems, setSelectedFilterItems] = useState([]);
  const sortOptions = [
    { name: "Name", href: "#", current: false },
    { name: "Email", href: "#", current: false },
    { name: "Sent Date", href: "#", current: false },
    { name: "Status", href: "#", current: true },
  ];
  const [remindInfoMenuShow, setRemindInfoMenuShow] = useState(false);
  const filterMenuRef = useRef(null);
  const [overviewStatus, setOverviewStatus] = useState([
    {
      title: "Sent",
      icon: (
        <svg
          className="size-5 mt-1"
          fill="#A1A1A1"
          strokeWidth="1"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.97975 1.07389C3.92356 1.52014 1.50831 3.94118 1.0708 7.0002H2.08287C2.50337 4.49345 4.47822 2.51374 6.9825 2.08599L6.97975 1.07389ZM8.98249 2.08014L8.97974 1.06812C12.055 1.49885 14.4896 3.92773 14.9291 7.0002H13.917C13.4945 4.48183 11.5033 2.4954 8.98249 2.08014ZM9.01467 13.9146C11.5201 13.4879 13.4962 11.5077 13.917 9.00019H14.929C14.4913 12.06 12.0748 14.4815 9.01742 14.9267L9.01467 13.9146ZM2.0829 9.0002C2.50529 11.5176 4.49522 13.5034 7.01468 13.9196L7.01743 14.9317C3.94351 14.4999 1.51022 12.0717 1.07083 9.0002H2.0829Z"
          ></path>
        </svg>
      ),
      checked: false,
    },
    {
      title: "Completed",
      icon: (
        <svg
          className="size-5 mt-1"
          fill="#83AF12"
          strokeWidth="1"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M8,1C4.1,1,1,4.1,1,8c0,3.9,3.1,7,7,7c3.9,0,7-3.1,7-7C15,4.1,11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z"></path>
          <path d="M10.6,6.1L7.5,9.2L5.9,7.6c-0.2-0.2-0.6-0.2-0.8,0s-0.2,0.6,0,0.8l2,2c0.1,0.1,0.3,0.2,0.4,0.2s0.3-0.1,0.4-0.2l3.5-3.5c0.2-0.2,0.2-0.6,0-0.8S10.8,5.8,10.6,6.1z"></path>
        </svg>
      ),
      checked: false,
    },
  ]);
  const handleClickOutside = (event) => {
    if (
      filterMenuRef.current &&
      !filterMenuRef.current.contains(event.target)
    ) {
      // Hide the search bar but keep the sortOptions visible
      setShowSearchBar(false);
      setFilterSearchTerm("");
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  async function checkAuth() {
    // window.location.reload();
    try {
      const cognitoUser = await Auth.currentAuthenticatedUser();
      const currentSession = await Auth.currentSession();
      await cognitoUser.refreshSession(
        currentSession.refreshToken,
        (err, session) => {
          const { idToken, refreshToken, accessToken } = session;
          getToken(idToken.jwtToken);
        }
      );
    } catch (e) {
      // console.log('Unable to refresh Token', e);
    }
  }

  useEffect(() => {
    getToken();
  }, []);

  async function getToken(token) {
    if (token) {
      setToken(token);
    } else {
      const currentSession = await Auth.currentSession();
      setToken(currentSession.idToken.jwtToken);
    }
  }

  useEffect(() => {
    console.log("survey rrecipients değişti");
    if (surveyRecipients) {
      console.log("surveyRecipients:", surveyRecipients);
      setRespondents(surveyRecipients.length);
      setCompleted(
        surveyRecipients.filter((us) => us.is_completed === true).length
      );
      setPartial(
        surveyRecipients.filter(
          (us) => us.is_completed === false && us.is_started
        ).length
      );
      let _data = surveyRecipients.map((us) => {
        return {
          id: us.ID,
          name: us.user_first_name + " " + us.user_last_name,
          email: us.user_email,
          sent_date: us.created_at,
          status: us.is_completed ? "completed" : "sent",
        };
      });
      setData(_data);
    }
  }, [surveyRecipients]);

  const [switchStates, setSwitchStates] = useState(
    sortOptions.reduce((acc, option) => {
      acc[option.name] = true; // Tüm switch'ler başlangıçta kapalı
      return acc;
    }, {})
  );

  const handleSwitchToggle = (name) => {
    setSwitchStates((prev) => ({
      ...prev,
      [name]: !prev[name], // Geçerli switch'in durumunu tersine çevir
    }));
  };

  const handleMenuItemClick = (label) => {
    setSelectedLabel(label); // Set selected label for filtering
    setShowSearchBar(true); // Show the search bar
  };

  const formatDate = (value) => {
    return new Date(value).toLocaleDateString("en-US", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // Filter rows based on selected label and search term

  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isSearchBarOpen, setIsSearchBarOpen] = useState(false);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [sortedData, setSortedData] = useState([]);
  // Toggle the visibility of the popup
  const togglePopup = () => {
    setIsPopupVisible(!isPopupVisible);
  };
  const toggleSearchBar = () => {
    setIsSearchBarOpen(!isSearchBarOpen);
  };

  const itemsPerPage = 1000;

  const filteredData = data.filter((row) =>
    row.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Paginate data
  const startIndex = (currentPage - 1) * itemsPerPage;

  useEffect(() => {
    const capitalizeFirstLetter = (str) => {
      return str.charAt(0).toUpperCase() + str.slice(1);
    };
    
    const filteredSearch = filteredData.filter((row) => {
      console.log(selectedLabel);
      console.log(filterSearchTerm);
      console.log(row);

      if (!selectedLabel || !filterSearchTerm) return true; // Eğer filtre seçilmemişse tüm veriyi göster

      return row[selectedLabel.toLowerCase()]
        ?.toLowerCase()
        .includes(filterSearchTerm.toLowerCase()); // Seçilen label ve arama terimine göre filtreleme
    });
    const filteredByStatus = filteredSearch.filter((row) =>
      selectedFilterItems.length > 0
        ? selectedFilterItems.includes(capitalizeFirstLetter(row.status))
        : true
    );
  
    // Eğer yeni filtrelenmiş veri aynıysa, state güncellemesi yapma
    setFilteredSearchData((prev) => {
      if (JSON.stringify(prev) === JSON.stringify(filteredByStatus)) {
        return prev; // Aynı veri, state güncellenmesin
      }
      return filteredByStatus;
    });
  }, [filteredData, selectedLabel, filterSearchTerm,selectedFilterItems]);

  const [sortConfig, setSortConfig] = React.useState({
    key: null,
    direction: "ascending",
  });
  useEffect(() => {
    if (sortConfig.key) {
      console.log(sortConfig);
      const sorted = [...filteredSearchData].sort((a, b) => {
        // Sayılar ve metinler için karşılaştırmayı türüne göre yap
        let valA = a[sortConfig.key];
        let valB = b[sortConfig.key];
        if (sortConfig.key === "name") {
          valA = a.first_name + " " + a.last_name;
          valB = b.first_name + " " + b.last_name;
        }
        // Verinin türüne göre karşılaştırma yap
        if (typeof valA === "string" && typeof valB === "string") {
          // String karşılaştırması (case-insensitive)
          const aLower = valA.toLowerCase();
          const bLower = valB.toLowerCase();

          if (aLower < bLower) {
            return sortConfig.direction === "ascending" ? -1 : 1;
          }
          if (aLower > bLower) {
            return sortConfig.direction === "ascending" ? 1 : -1;
          }
        } else if (typeof valA === "number" && typeof valB === "number") {
          // Sayısal karşılaştırma
          if (valA < valB) {
            return sortConfig.direction === "ascending" ? -1 : 1;
          }
          if (valA > valB) {
            return sortConfig.direction === "ascending" ? 1 : -1;
          }
        }
        return 0;
      });
      console.log(sorted);
      setSortedData(sorted);
    } else {
      setSortedData(filteredSearchData);
    }
  }, [filteredData, filteredSearchData, sortConfig]);
  const handleStatusClick = (status) => {
    const updatedStatus = overviewStatus.map((item) => {
      if (item.title === status.title) {
        item.checked = !item.checked;
      }
      return item;
    });
    setOverviewStatus(updatedStatus);
  };
  const filterSortedData = (selectedStatuses) => {
    const capitalizeFirstLetter = (str) => {
      return str.charAt(0).toUpperCase() + str.slice(1);
    };
    const filtered = sortedData.filter((data) =>
      selectedStatuses.includes(capitalizeFirstLetter(data.status))
    );
    console.log(filtered);
    setSortedData(filtered);
  };
  const previousOverviewStatus = useRef();
  useEffect(() => {
    // Check if surveyStatus has changed (without stringify)
    if (previousOverviewStatus.current !== overviewStatus) {
      // Filter checked items and get their titles
      const selectedTitles = overviewStatus
        .filter((status) => status.checked)
        .map((status) => status.title);

      // If no selected titles, take all titles
      const allTitles = overviewStatus.map((status) => status.title);
      const finalTitles =
        selectedTitles.length > 0 ? selectedTitles : allTitles;

      console.log(finalTitles);
      setSelectedFilterItems(selectedTitles); // Update selectedFilterItems
      filterSortedData(finalTitles); // Filter surveys based on titles

      // Update previousSurveyStatus to the latest surveyStatus
      previousOverviewStatus.current = overviewStatus;
    }
  }, [overviewStatus]);
  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const sendRemindMail = (row) => {
    console.log("sendRemindMail:", row);
    const _userSurvey = surveyRecipients.find((us) => us.ID === row.id);
    const obj = {
      user_survey_id: _userSurvey.ID,
      survey_id: _userSurvey.survey_id,
      user: {
        email: _userSurvey.user_email,
        first_name: _userSurvey.user_first_name,
        last_name: _userSurvey.user_last_name,
      },
    };
    sendSurveyRemind(obj);
  };

  async function sendSurveyRemind(obj) {
    await sendSurveyFromAPI(token, obj)
      .then((result) => {
        setInfoText("Remind mail sent");
        setSuccess(true);
        setError(false);
        setRemindInfoMenuShow(true);
      })
      .catch((error) => {
        setInfoText("An error occurred while sending the reminder email.");
        setSuccess(false);
        setError(true);
        setRemindInfoMenuShow(true);
      });
  }
  useEffect(() => {
    // Automatically close the dialog after 5 seconds
    const timer = setTimeout(() => {
      setRemindInfoMenuShow(false);
    }, 3000); // 5000 ms = 5 seconds

    // Cleanup the timer when the component unmounts or dialog closes
    return () => clearTimeout(timer);
  }, [remindInfoMenuShow, setRemindInfoMenuShow]);
  return (
    <div
      className={` w-auto h-full   ${
        themeMode === "dark"
          ? "bg-[#1a1a28] text-white"
          : "bg-white text-gray-800"
      }`}
    >
      <div
        className={`flex  justify-start flex-shrink-0 min-w-0 h-auto lg:h-[50px] px-0 lg:px-12 py-2 lg:py-0 space-y-1 lg:space-y-0 flex-col sm:flex-col md:flex-col lg:flex-row lg:justify-between lg:items-center divide-y divide-solid divide-[1px] lg:divide-0 ${
          themeMode === "dark" ? "divide-white-06" : "divide-black-06"
        }`}
      >
        <div
          className={`flex mr-2 gap-[0.25rem] px-12 lg:px-0 pb-1 lg-:pb-0 flex-wrap sm:flex-nowrap`}
        >
          <Menu
            as="div"
            className="relative inline-block text-left mt-1 lg:mt-0"
          >
            <div>
              <MenuButton
                className={`flex items-center self-stretch p-0 pr-1 h-[1.5rem] lg:h-[2rem] min-w-8  rounded-md shadow-inner cursor-text  ${
                  themeMode === "dark"
                    ? "bg-white-02"
                    : "bg-black-02 shadow-[0_0_0_1px_rgba(0,0,0,0.09)]"
                } `}
              >
                <div
                  className={`hulyButton font-medium-14 h-[1.5rem] w-[1.5rem] lg:h-[2rem] lg:w-[2rem] border rounded-[0.375rem] cursor-pointer flex justify-center  items-center ${
                    themeMode === "dark"
                      ? "border-[#d1d5de0a] bg-[#d1d5de0d] hover:bg-[#d1d5de0a]"
                      : "border-[#1725471a] bg-[#1725470d] hover:bg-[#1725471a]"
                  }`}
                  data-id="btn-viewSetting"
                >
                  <div
                    className={`icon no-gap  inline-flex justify-center  items-center  ${
                      themeMode === "dark" ? "text-[#ffffff]" : "text-[#000]"
                    }`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className={`size-4 lg:size-5`}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75"
                      />
                    </svg>
                  </div>
                </div>
              </MenuButton>
            </div>

            <MenuItems
              transition
              className={`absolute left-1 z-[99999999] mt-2 w-40 origin-top-right rounded-md shadow-2xl ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in  border-solid border-[1px] ${
                themeMode === "dark"
                  ? " bg-[#2a2939] border-white-09 shadow-theme-popup-shadow "
                  : "bg-[#FFFFFF] border-black-09 shadow-black-2-shadow"
              }`}
            >
              <div className="py-1">
                {sortOptions.map((option, index) => (
                  <div key={option.name} className="mb-4">
                    <div
                      className={`flex-shrink-0 flex justify-between px-2 py-1 min-w-0 min-h-[2.25rem] text-left rounded-md ${
                        themeMode === "dark"
                          ? "hover:bg-[#333240] text-white"
                          : "hover:bg-[#EBEBEB] text-black"
                      }`}
                    >
                      <label
                        htmlFor={`switch-${index}`}
                        className={`ms-3 text-sm font-medium ${
                          themeMode === "dark"
                            ? "text-[#f7f8f8]"
                            : "text-[#131416]"
                        }`}
                      >
                        {option.name}
                      </label>

                      <div className="relative inline-block w-11 h-5">
                        <input
                          id={`switch-${index}`}
                          type="checkbox"
                          className="peer appearance-none w-11 h-5 bg-[rgba(120,120,128,0.32)] rounded-full checked:bg-[#205dc2] cursor-pointer transition-colors duration-300"
                          checked={switchStates[option.name]} // Durumdan gelen değer
                          onChange={() => handleSwitchToggle(option.name)} // Tıklamayı işle
                        />
                        <label
                          htmlFor={`switch-${index}`}
                          className="absolute top-0 left-0 w-5 h-5 bg-white rounded-full border border-slate-300 shadow-sm transition-transform duration-300 peer-checked:translate-x-6 peer-checked:border-slate-800 cursor-pointer"
                        ></label>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </MenuItems>
          </Menu>
          <div className="flex items-center justify-center text-center">
            <label
              className={`hulyButton font-medium h-[1.5rem] w-[1.5rem] lg:h-[2rem] lg:min-w-8 mr-1 w-auto border gap-2 rounded-[0.375rem] flex justify-between px-1 items-center ${
                themeMode === "dark"
                  ? "border-[#d1d5de0a] bg-[#d1d5de0d] hover:bg-[#d1d5de0a]"
                  : "border-[#1725471a] bg-[#1725470d] hover:bg-[#1725471a]"
              }`}
              data-id="btn-viewSetting"
            >
              <UsersIcon
                className={`size-4 lg:size-5 ${
                  themeMode === "dark" ? "text-[#ffffff]" : "text-[#0f121a]"
                }`}
              ></UsersIcon>
            </label>

            <div className="flex gap-1 font-medium h-[2rem] items-center">
              <span className="overflow-label label disabled pointer-events-none whitespace-nowrap break-all text-ellipsis overflow-hidden min-w-0 text-xs lg:text-sm">
                RESPONDENTS
              </span>
              <span className="overflow-label label disabled pointer-events-none whitespace-nowrap break-all text-ellipsis overflow-hidden min-w-0 text-xs lg:text-sm">
                {respondents}
              </span>
            </div>
          </div>
          <div className="flex items-center justify-center text-center">
            <label
              className={`hulyButton font-medium h-[1.5rem] w-[1.5rem] lg:h-[2rem] lg:min-w-8  mr-1  border gap-2 rounded-[0.375rem] flex justify-between px-1 items-center ${
                themeMode === "dark"
                  ? "border-[#d1d5de0a] bg-[#d1d5de0d] hover:bg-[#d1d5de0a]"
                  : "border-[#1725471a] bg-[#1725470d] hover:bg-[#1725471a]"
              }`}
              data-id="btn-viewSetting"
            >
              <EnvelopeOpenIcon
                className={`size-4 lg:size-5 ${
                  themeMode === "dark" ? "text-[#ffffff]" : "text-[#0f121a]"
                }`}
              ></EnvelopeOpenIcon>
            </label>

            <div className="flex gap-1 font-medium  h-[2rem] items-center">
              <span className="overflow-label label disabled pointer-events-none whitespace-nowrap break-all text-ellipsis overflow-hidden min-w-0 text-xs lg:text-sm">
                COMPLETED
              </span>
              <span className="overflow-label label disabled pointer-events-none whitespace-nowrap break-all text-ellipsis overflow-hidden min-w-0 text-xs lg:text-sm">
                {completed}
              </span>
            </div>
          </div>
          <div className="flex items-center justify-center text-center">
            <label
              className={`hulyButton font-medium h-[1.5rem] w-[1.5rem] lg:h-[2rem] lg:min-w-8  mr-1  border gap-2 rounded-[0.375rem] flex justify-between px-1 items-center ${
                themeMode === "dark"
                  ? "border-[#d1d5de0a] bg-[#d1d5de0d] hover:bg-[#d1d5de0a]"
                  : "border-[#1725471a] bg-[#1725470d] hover:bg-[#1725471a]"
              }`}
              data-id="btn-viewSetting"
            >
              <ClockIcon
                className={`size-4 lg:size-5 ${
                  themeMode === "dark" ? "text-[#ffffff]" : "text-[#0f121a]"
                }`}
              ></ClockIcon>
            </label>

            <div className="flex gap-1 font-medium h-[2rem] items-center">
              <span className="overflow-label label disabled pointer-events-none whitespace-nowrap break-all text-ellipsis overflow-hidden min-w-0 text-xs lg:text-sm">
                PARTIAL
              </span>
              <span className="overflow-label label disabled pointer-events-none whitespace-nowrap break-all text-ellipsis overflow-hidden min-w-0 text-xs lg:text-sm">
                {partial}
              </span>
            </div>
          </div>
        </div>
        <div className="flex flex-end gap-2 px-12 pt-2 lg:pt-0 lg:px-0">
          <label
            className={`flex items-center self-stretch p-0 pr-1 h-[2rem] min-w-8  rounded-md shadow-inner cursor-text transition-all max-w-8 focus-within:max-w-[15rem] focus-within:pr-1 focus-within:p-0.25 active:max-w-[15rem] active:pr-1 active:p-0.25 ${
              themeMode === "dark"
                ? "bg-white-02"
                : "bg-black-02 shadow-[0_0_0_1px_rgba(0,0,0,0.09)]"
            }`}
          >
            <div
              className={`flex items-center justify-center flex-shrink-0 p-0 bg-transparent border-none outline-none cursor-pointer rounded-md h-8 w-8  mr-1 focus-within:cursor-text ${
                themeMode === "dark" ? "text-white" : "text-[#0f121a]"
              }`}
            >
              <svg
                className="w-[1rem] h-[1rem]"
                fill="currentColor"
                viewBox="0 0 16 16"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  file-rule="evenodd"
                  clipRule="evenodd"
                  d="M10.7241 10.0168L14.3535 13.6465C14.5488 13.8417 14.5488 14.1583 14.3535 14.3536C14.1602 14.5469 13.8478 14.5488 13.6522 14.3592L10.017 10.7238C8.9277 11.6312 7.5305 12.0836 6.11608 11.9871C4.70165 11.8905 3.37891 11.2524 2.423 10.2054C1.4671 9.15843 0.951637 7.78323 0.983845 6.36588C1.01605 4.94853 1.59345 3.59816 2.59593 2.59568C3.5984 1.59321 4.94877 1.01581 6.36612 0.983601C7.78347 0.951393 9.15867 1.46686 10.2057 2.42276C11.2526 3.37866 11.8908 4.70141 11.9873 6.11583C12.0839 7.53026 11.6314 8.92745 10.7241 10.0168ZM2.75851 3.99981C2.26404 4.73983 2.00012 5.60986 2.00012 6.49987C2.00144 7.69294 2.47597 8.83677 3.3196 9.68039C4.16323 10.524 5.30705 10.9986 6.50012 10.9999C7.39013 10.9999 8.26016 10.736 9.00018 10.2415C9.7402 9.74702 10.317 9.04422 10.6576 8.22195C10.9982 7.39968 11.0873 6.49488 10.9137 5.62197C10.74 4.74905 10.3114 3.94723 9.6821 3.31789C9.05276 2.68856 8.25094 2.25997 7.37802 2.08634C6.50511 1.91271 5.60031 2.00182 4.77804 2.34242C3.95578 2.68301 3.25297 3.25979 2.75851 3.99981Z"
                ></path>
              </svg>
            </div>
            <input
              type="text"
              className={`mr-3 p-0 w-full h-full ${
                themeMode === "dark"
                  ? "text-white placeholder:text-white"
                  : "text-[#0f121a] placeholder:text-[#0f121a]"
              } caret-[#2a59d6] bg-transparent border-none outline-none appearance-none`}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search"
              autoComplete="off"
              spellCheck="false"
            />
          </label>
          <div className="flex items-center">
            <Menu as="div">
              <div>
                <MenuButton
                  className={`flex items-center self-stretch p-0 pr-1 h-[2rem] min-w-8  rounded-md shadow-inner border border-[#ffffff17]  ${
                    themeMode === "dark"
                      ? "bg-[#ffffff05] hover:bg-[#ffffff0a]"
                      : "bg-black-02 shadow-[0_0_0_1px_rgba(0,0,0,0.09)]"
                  } `}
                >
                  {selectedFilterItems.length !== 0 ? (
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedFilterItems([]);
                        setSortedData(filteredSearchData);
                        setOverviewStatus(
                          overviewStatus.map((status) => {
                            status.checked = false;
                            return status;
                          })
                        );
                      }} // Reset search term to empty string
                      className={`flex items-center justify-center gap-3 p-0 px-3 cursor-pointer bg-transparent border border-transparent rounded-md text-sm  min-w-[1.375rem] whitespace-nowrap transition-all duration-150 hover:bg-black-200 hover:border-black-900  ${
                        themeMode === "dark"
                          ? "hover:text-[#fff] text-white"
                          : "hover:text-[#000] text-black-8"
                      }`}
                    >
                      <div
                        className={`btn-icon pointer-events-none ${
                          themeMode === "dark" ? "text-white-8" : "text-black-8"
                        }`}
                      >
                        <svg
                          className="svg-small w-[.8rem] h-[.8rem] mr-1"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M8.7,8l4.6-4.6c0.2-0.2,0.2-0.5,0-0.7s-0.5-0.2-0.7,0L8,7.3L3.4,2.6c-0.2-0.2-0.5-0.2-0.7,0s-0.2,0.5,0,0.7L7.3,8l-4.6,4.6c-0.2,0.2-0.2,0.5,0,0.7c0.1,0.1,0.2,0.1,0.4,0.1s0.3,0,0.4-0.1L8,8.7l4.6,4.6c0.1,0.1,0.2,0.1,0.4,0.1s0.3,0,0.4-0.1c0.2-0.2,0.2-0.5,0-0.7L8.7,8z"></path>
                        </svg>
                      </div>
                      <span className="overflow-label label disabled pointer-events-none whitespace-nowrap break-all text-ellipsis overflow-hidden min-w-0">
                        Clear filter
                      </span>
                    </div>
                  ) : (
                    <div
                      className={`flex items-center justify-center gap-3 p-0 px-3 cursor-pointer bg-transparent border border-transparent rounded-md text-sm  min-w-[1.375rem] whitespace-nowrap transition-all duration-150 hover:bg-black-200 hover:border-black-900  ${
                        themeMode === "dark"
                          ? "hover:text-[#fff] text-white"
                          : "hover:text-[#000] text-black-8"
                      }`}
                      type="button"
                      onClick={() => {
                        setFilterSearchTerm("");
                        setShowSearchBar(false);
                        togglePopup();
                      }}
                    >
                      <div className="pointer-events-none">
                        <svg
                          className="w-4 h-4"
                          fill="currentColor"
                          viewBox="0 0 32 32"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M29.9,4.1c-0.1-0.4-0.4-0.8-0.7-1.1c-0.3-0.3-0.7-0.5-1.1-0.7c-0.1,0-0.2-0.1-0.3-0.1H4.2c-0.1,0-0.2,0-0.3,0.1C3.5,2.5,3.1,2.7,2.8,3C2.5,3.3,2.3,3.7,2.1,4.1C2,4.5,2,5,2,5.4c0.1,0.4,0.2,0.8,0.5,1.2c0,0,0.1,0.1,0.1,0.1l8.8,9.7v6.9c0,0.3,0.1,0.6,0.4,0.8l7.3,5.4c0.2,0.1,0.4,0.2,0.6,0.2c0.2,0,0.3,0,0.4-0.1c0.3-0.2,0.6-0.5,0.6-0.9V16.4l8.8-9.7c0,0,0.1-0.1,0.1-0.1c0.2-0.4,0.4-0.8,0.5-1.2C30,5,30,4.5,29.9,4.1z M27.9,5.4l-9,9.9c-0.2,0.2-0.3,0.4-0.3,0.7v10.7l-5.3-3.9V16c0-0.2-0.1-0.5-0.3-0.7l-9-9.9C4.1,5.3,4,5.2,4,5.1C4,5,4,4.9,4,4.8c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.1-0.1,0.2-0.1h23.2c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.2,0.2,0.2,0.3C28,4.9,28,5,28,5.1C28,5.2,27.9,5.3,27.9,5.4z"></path>
                        </svg>
                      </div>
                      <span className="overflow-hidden text-ellipsis whitespace-nowrap ">
                        Filter
                      </span>
                    </div>
                  )}
                </MenuButton>
              </div>

              <MenuItems
                transition
                className={`absolute right-30 z-10 mt-2 w-40 origin-top-right rounded-md shadow-2xl ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in  border-solid border-[1px] ${
                  themeMode === "dark"
                    ? " bg-[#2a2939] border-white-09 shadow-theme-popup-shadow "
                    : "bg-[#FFFFFF] border-black-09 shadow-black-2-shadow"
                }`}
              >
                <div className="py-1">
                  <div className="px-1 py-2">
                    <input
                      type="text"
                      placeholder="Search..."
                      value={filterSearchTerm}
                      onChange={(e) => setFilterSearchTerm(e.target.value)}
                      className={`w-full px-2 py-1 mb-2 rounded-md ${
                        themeMode === "dark"
                          ? " bg-[#2a2939]  shadow-theme-popup-shadow  placeholder:text-white-6 text-white-6"
                          : "bg-[#FFFFFF] shadow-black-2-shadow placeholder:text-black text-black"
                      }`}
                    />
                    <div className="flex-grow min-h-0 h-max overflow-x-hidden overflow-y-auto">
                      <div className="flex flex-col h-full">
                        {overviewStatus
                          .filter(
                            (status) =>
                              !filterSearchTerm.trim() || // Eğer arama terimi boşsa tüm öğeleri döndür
                              status.title
                                .toLowerCase()
                                .includes(filterSearchTerm.toLowerCase())
                          )
                          .map((status, index) => (
                            <button
                              key={index}
                              onClick={() => handleStatusClick(status)}
                              className={`mx-2 cursor-pointer flex-shrink-0 justify-start p-1 px-2 min-w-0 min-h-[2.25rem] text-left ${
                                themeMode === "dark"
                                  ? "text-white bg-[2a2939] hover:bg-[#333240]"
                                  : "text-black bg-[#FFFFFF] hover:bg-[#EBEBEB]"
                              } rounded`}
                            >
                              <div className="flex justify-between items-center min-w-0 min-h-0 w-full">
                                <div className="flex items-center justify-between flex-nowrap min-w-0 min-h-0 w-full">
                                  <div
                                    className={`flex items-center ${
                                      themeMode === "dark"
                                        ? "text-white"
                                        : "text-black"
                                    } flex-wrap-nowrap min-w-0 cursor-pointer`}
                                  >
                                    <div className="">{status.icon}</div>
                                    <span className="ml-2 whitespace-nowrap break-words truncate overflow-hidden min-w-0">
                                      {status.title}
                                    </span>
                                  </div>
                                  {status.checked && (
                                    <div className="pointer-events-none">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        className="w-4 h-4"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="m4.5 12.75 6 6 9-13.5"
                                        />
                                      </svg>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </button>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              </MenuItems>
            </Menu>
          </div>
          <div className="flex items-center hidden">
            <Menu
              as="div"
              className="relative inline-block text-left"
              ref={filterMenuRef}
            >
              <div>
                <MenuButton
                  className={`flex items-center self-stretch p-0 pr-1 h-[2rem] min-w-8  rounded-md shadow-inner cursor-text  ${
                    themeMode === "dark"
                      ? "bg-white-02"
                      : "bg-black-02 shadow-[0_0_0_1px_rgba(0,0,0,0.09)]"
                  } `}
                >
                  {filterSearchTerm !== "" ? (
                    <div
                      onClick={() => {
                        setFilterSearchTerm("");
                        setShowSearchBar(false);
                      }} // Reset search term to empty string
                      className={`px-3 py-1 text-sm border  flex justify-jenter items-center rounded-[0.375rem] border-solid ${
                        themeMode === "dark"
                          ? " bg-white-02 border-white-09 hover:bg-white-08"
                          : " bg-black-02 border-black-09 hover:bg-black-08 "
                      }`}
                    >
                      <div
                        className={`btn-icon pointer-events-none ${
                          themeMode === "dark" ? "text-white-8" : "text-black-8"
                        }`}
                      >
                        <svg
                          className="svg-small  w-[.8rem] h-[.8rem]"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M8.7,8l4.6-4.6c0.2-0.2,0.2-0.5,0-0.7s-0.5-0.2-0.7,0L8,7.3L3.4,2.6c-0.2-0.2-0.5-0.2-0.7,0s-0.2,0.5,0,0.7L7.3,8l-4.6,4.6c-0.2,0.2-0.2,0.5,0,0.7c0.1,0.1,0.2,0.1,0.4,0.1s0.3,0,0.4-0.1L8,8.7l4.6,4.6c0.1,0.1,0.2,0.1,0.4,0.1s0.3,0,0.4-0.1c0.2-0.2,0.2-0.5,0-0.7L8.7,8z"></path>
                        </svg>
                      </div>
                      <span className="overflow-label label disabled pointer-events-none whitespace-nowrap break-all text-ellipsis overflow-hidden min-w-0">
                        Clear filter
                      </span>
                    </div>
                  ) : (
                    <div
                      className={`flex items-center justify-center gap-3 p-0 px-3 bg-transparent border border-transparent rounded-md text-sm  min-w-[1.375rem] whitespace-nowrap transition-all duration-150 hover:bg-black-200 hover:border-black-900  ${
                        themeMode === "dark"
                          ? "hover:text-[#fff] text-white-8"
                          : "hover:text-[#000] text-black-8"
                      }`}
                      type="button"
                      onClick={() => {
                        setFilterSearchTerm("");
                        setShowSearchBar(false);
                        togglePopup();
                      }}
                    >
                      <div className="pointer-events-none">
                        <svg
                          className="w-4 h-4"
                          fill="currentColor"
                          viewBox="0 0 32 32"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M29.9,4.1c-0.1-0.4-0.4-0.8-0.7-1.1c-0.3-0.3-0.7-0.5-1.1-0.7c-0.1,0-0.2-0.1-0.3-0.1H4.2c-0.1,0-0.2,0-0.3,0.1C3.5,2.5,3.1,2.7,2.8,3C2.5,3.3,2.3,3.7,2.1,4.1C2,4.5,2,5,2,5.4c0.1,0.4,0.2,0.8,0.5,1.2c0,0,0.1,0.1,0.1,0.1l8.8,9.7v6.9c0,0.3,0.1,0.6,0.4,0.8l7.3,5.4c0.2,0.1,0.4,0.2,0.6,0.2c0.2,0,0.3,0,0.4-0.1c0.3-0.2,0.6-0.5,0.6-0.9V16.4l8.8-9.7c0,0,0.1-0.1,0.1-0.1c0.2-0.4,0.4-0.8,0.5-1.2C30,5,30,4.5,29.9,4.1z M27.9,5.4l-9,9.9c-0.2,0.2-0.3,0.4-0.3,0.7v10.7l-5.3-3.9V16c0-0.2-0.1-0.5-0.3-0.7l-9-9.9C4.1,5.3,4,5.2,4,5.1C4,5,4,4.9,4,4.8c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.1-0.1,0.2-0.1h23.2c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.2,0.2,0.2,0.3C28,4.9,28,5,28,5.1C28,5.2,27.9,5.3,27.9,5.4z"></path>
                        </svg>
                      </div>
                      <span className="overflow-hidden text-ellipsis whitespace-nowrap text-gray-500 cursor-not-allowed">
                        Filter
                      </span>
                    </div>
                  )}
                </MenuButton>
              </div>

              <MenuItems
                transition
                className={`absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md shadow-2xl ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in  border-solid border-[1px] ${
                  themeMode === "dark"
                    ? " bg-[#2a2939] border-white-09 shadow-theme-popup-shadow "
                    : "bg-[#FFFFFF] border-black-09 shadow-black-2-shadow"
                }`}
              >
                <div className="py-1">
                  {showSearchBar && clearFilter ? (
                    <div className="px-4 py-2">
                      <input
                        type="text"
                        placeholder="Search..."
                        value={filterSearchTerm}
                        onChange={(e) => setFilterSearchTerm(e.target.value)}
                        className={`w-full px-2 py-1 border rounded-md  ${
                          themeMode === "dark"
                            ? " bg-[#2a2939] border-white-09 shadow-theme-popup-shadow  placeholder:text-white-6 text-white-6"
                            : "bg-[#FFFFFF] border-black-09 shadow-black-2-shadow placeholder:text-black-6 text-black-6"
                        }`}
                      />
                    </div>
                  ) : (
                    sortOptions.map((option) => (
                      <MenuItem key={option.name}>
                        <a
                          href={option.href}
                          className={`${
                            themeMode === "dark"
                              ? "text-[#fff] hover:bg-[#333240]"
                              : "text-[#000] hover:bg-[#EBEBEB]"
                          } block px-4 py-2 text-sm data-[focus]:outline-none`}
                          onClick={(e) => {
                            e.preventDefault(); // Varsayılan bağlantı davranışını durdurur
                            e.stopPropagation(); // Tıklamanın menüyü kapatmasını engeller
                            handleMenuItemClick(option.name);
                          }}
                        >
                          {option.name}
                        </a>
                      </MenuItem>
                    ))
                  )}
                </div>
              </MenuItems>
            </Menu>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto flex-1 ">
        <table
          className={`min-w-full border border-b border-solid border-[1px] table-fixed ${
            themeMode === "dark"
              ? " bg-[#1C1C29] border-white-06"
              : "bg-[#efeff2] border-black-06"
          }`}
        >
          <thead
            className={`border border-b border-t-0 border-r-0 border-l-0 border-solid border-[1px] px-8 ${
              themeMode === "dark"
                ? "bg-[#1C1C29] border-white-06"
                : "bg-[#efeff2] border-black-06"
            }`}
          >
            <tr>
              {switchStates["Name"] && (
                <th
                  onClick={() => handleSort("name")}
                  className={`cursor-pointer h-12 p-2.5 pl-12 font-semibold text-xs tracking-tight text-start uppercase custom-shadow-light w-1/5 ${
                    themeMode === "dark"
                      ? "text-white text-opacity-60"
                      : "text-gray-600"
                  }`}
                >
                  <div className="flex justify-start gap-2">
                    Name{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="size-4"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3 7.5 7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"
                      />
                    </svg>
                  </div>
                </th>
              )}
              {switchStates["Email"] && (
                <th
                  onClick={() => handleSort("email")}
                  className={`cursor-pointer p-2.5 pl-6 h-12 font-semibold text-xs tracking-tight text-start uppercase custom-shadow-light w-1/5 ${
                    themeMode === "dark"
                      ? "text-white text-opacity-60"
                      : "text-gray-600"
                  }`}
                >
                  <div className="flex justify-start gap-2">
                    Email
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="size-4"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3 7.5 7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"
                      />
                    </svg>
                  </div>
                </th>
              )}
              {switchStates["Sent Date"] && (
                <th
                  onClick={() => handleSort("sent_date")}
                  className={`cursor-pointer p-2.5 pl-6 h-12 font-semibold text-xs tracking-tight text-start uppercase custom-shadow-light w-1/5 ${
                    themeMode === "dark"
                      ? "text-white text-opacity-60"
                      : "text-gray-600"
                  }`}
                >
                  <div className="flex justify-start gap-2">
                    Sent Date
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="size-4"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M3 7.5 7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"
                      />
                    </svg>
                  </div>
                </th>
              )}
              {switchStates["Status"] && (
                <th
                  onClick={() => handleSort("status")}
                  className={`cursor-pointer p-2.5 pl-6 h-12 font-semibold text-xs tracking-tight text-start uppercase custom-shadow-light w-1/5 ${
                    themeMode === "dark"
                      ? "text-white text-opacity-60"
                      : "text-gray-600"
                  }`}
                >
                  <div className="flex justify-start gap-2">
                    Status{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="size-4"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3 7.5 7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"
                      />
                    </svg>
                  </div>
                </th>
              )}
              <th
                className={`p-2.5 pl-6 h-12 font-semibold text-xs tracking-tight text-start uppercase custom-shadow-light  ${
                  themeMode === "dark"
                    ? "text-white text-opacity-60"
                    : "text-gray-600"
                }`}
              >
                Remind
              </th>
            </tr>
          </thead>

          <tbody
            className={`${
              themeMode === "dark" ? "bg-[#21212F]" : "bg-[#f4f4f6]"
            }`}
          >
            {sortedData.map((row) => (
              <tr
                key={row.id}
                className={`relative h-13 border-b ${
                  themeMode === "dark"
                    ? "text-[#FFF] hover:bg-[#282834] border-[rgba(255,255,255,0.06)]"
                    : "hover:bg-[#E8E8E9] border-[rgba(0,0,0,0.06)]"
                }`}
              >
                {switchStates["Name"] && (
                  <td className="p-2.5 pl-12 text-start text-sm relative">
                    {row.name}
                  </td>
                )}
                {switchStates["Email"] && (
                  <td className="p-2.5 pl-6 text-start text-sm relative">
                    {row.email}
                  </td>
                )}
                {switchStates["Sent Date"] && (
                  <td className="p-2.5 pl-6 text-start text-sm relative">
                    {formatDate(row.sent_date)}
                  </td>
                )}
                {switchStates["Status"] && row.status === "sent" && (
                  <td className="p-2.5 pl-6 text-start text-sm relative">
                    <div className="flex">
                      <div
                        className={`px-2 cursor-pointer h-6 w-auto rounded-lg text-xxs uppercase text-white bg-[#147cc5] border border-[#46A44F0f] flex items-center justify-center`}
                      >
                        {row.status}
                      </div>
                    </div>
                  </td>
                )}
                {switchStates["Status"] && row.status === "completed" && (
                  <td className="p-2.5 pl-6 text-start text-sm relative">
                    <div className="flex">
                      <div
                        className={`px-2 cursor-pointer h-6 w-auto rounded-lg text-xxs uppercase ${
                          themeMode === "dark"
                            ? "text-white bg-gray-600"
                            : "bg-gray-200 text-gray-600"
                        } border border-[#46A44F0f] flex items-center justify-center`}
                      >
                        {row.status}
                      </div>
                    </div>
                  </td>
                )}
                {row.status === "sent" ? (
                  <td className="p-2.5 pl-6 text-start text-sm relative">
                    <div className="antiTable-cells__firstCell">
                      <div className="buttons-group xxsmall-gap">
                        <button
                          className="antiButton link-bordered small jf-center sh-circle bs-solid gap-medium only-icon"
                          disabled={
                            currentSurvey.status.toLowerCase() === "completed"
                          }
                          type="button"
                          id="gmail:string:Email"
                          onClick={() => sendRemindMail(row)}
                        >
                          <div className="btn-icon pointer-events-none">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth={1.5}
                              stroke="currentColor"
                              className="size-6"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
                              />
                            </svg>
                          </div>
                        </button>
                      </div>
                    </div>
                  </td>
                ) : (
                  <div className="antiTable-cells__firstCell">
                    <div className="buttons-group xxsmall-gap"></div>
                  </div>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      <div
        className={`flex justify-start items-center pr-8 bottom-0 fixed mt-4 1 ${
          themeMode === "dark" ? "bg-[#1F1F2C]" : "bg-[#fbfbfc]"
        } h-[2.5rem] w-full`}
      >
        <label
          className={`space-x-2 pl-[2.5rem] ${
            themeMode === "dark" ? "text-[#868a94]" : "text-[#54585f]"
          } text-[0.875rem]`}
        >
          <span>Total:</span>
          <span>{Math.ceil(filteredData.length)}</span>
        </label>
      </div>
      <Dialog
        open={remindInfoMenuShow}
        onClose={setRemindInfoMenuShow}
        className="relative z-10"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0  transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto px-[4.7rem] pb-0">
          <div className="flex min-h-full items-end absolute px-20 justify-start p-4 text-center  sm:p-0">
            <DialogPanel
              transition
              className={`relative transform  rounded-lg shadow-black-2-shadow border border-solid ${
                themeMode === "dark"
                  ? "bg-[#2a2939] border-white-09"
                  : "bg-[#FFFFFF] border-black-09 "
              } overflow-hidden rounded-lg   px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-4 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
            >
              <div>
                <div className="mt-0 text-start sm:mt-0">
                  <DialogTitle
                    as="h3"
                    className={`text-base font-semibold flex flex-row justify-start ${
                      themeMode === "dark" ? "text-[#fff]" : "text-[#000]"
                    }`}
                  >
                    {success && (
                      <div className="flex flex-row justify-start">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className="size-6"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                            fill="#008000"
                            stroke="#fff"
                          />
                        </svg>
                        <span>{infoText}</span>
                      </div>
                    )}
                    {error && (
                      <div className="flex flex-row justify-start">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className="size-6"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                          />
                        </svg>
                        <span>{infoText}</span>
                      </div>
                    )}
                  </DialogTitle>
                </div>
              </div>
              <div className="flex-shrink-0 grid grid-flow-col rtl justify-end items-center gap-2 mt-2">
                <button
                  type="button"
                  onClick={() => setRemindInfoMenuShow(false)}
                  className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid bg-[#205dc2] hover:bg-[#3575de] hover:text-white text-white  ${
                    themeMode === "dark"
                      ? " border-white-09  "
                      : " border-black-09 "
                  } px-3 py-2 text-sm font-semibold shadow-sm sm:col-start-2 sm:mt-0`}
                >
                  Ok
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
